import http from './http';
import { EventRecord, RecordTypes } from '../../../app/models/event';

async function fetchNotes(search_text: string): Promise<EventRecord<RecordTypes>[]> {
  const {data} = await http.get(`/notes/${search_text}`);
  return data;
}

export default fetchNotes;
